<template>
	<el-dialog :visible=" show " :title="row ? '编辑作品' : '新建作品' " width="770px" append-to-body :close-on-click-modal="false" @close="closeDialog">
		<el-form ref="vForm" label-width="100px" :model="vForm" size="medium">
			<el-form-item label="排序" prop="sort" :rules="{required:true,message:'排序必填'}">
				<el-input v-model="vForm.sort"></el-input>
				<div class="v-form-tips">排序值越小越靠前</div>
			</el-form-item>
			<el-form-item label="全景标题" prop="name" :rules="{required:true,message:'标题必填'}">
				<el-input v-model="vForm.name"></el-input>
			</el-form-item>
			<el-form-item v-loading="categoryLoading" label="作品分类" prop="categoryId" :rules="{required:true,message:'分类必填'}">
				<el-select v-model="vForm.categoryId" multiple placeholder="请选择" style="width:100%;" filterable>
					<el-option v-for="item in category" :key="item.id" :label="item.name" :value="item.id.toString()"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="经纬度" required>
				<el-input v-model="vForm.lng" placeholder="经度" style="width:180px"></el-input>
				<el-input v-model="vForm.lat" placeholder="经度" style="width:180px;margin: 0 10px"></el-input>
				<el-button type="success" @click="isShowMap=true;isShowMapDialog=true;">点图选点</el-button>
			</el-form-item>
			<el-form-item label="作品类型">
				<el-radio v-model="vForm.type" :label="1" :disabled="!!row">普通作品</el-radio>
				<el-radio v-model="vForm.type" :label="2" :disabled="!!row">外链作品</el-radio>
				<el-radio v-model="vForm.type" :label="3" :disabled="!!row">复拍作品</el-radio>
			</el-form-item>
			<el-form-item v-if="vForm.type == 3 && !row" label="拍摄日期" :rules="{required:true,message:'拍摄日期必填'}">
				<el-date-picker v-model="vForm.remarkTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width:100%;"></el-date-picker>
			</el-form-item>
			<el-form-item v-if="!row && vForm.type != 2" label="全景图片">
				<vr-upload v-model="vForm.materialData" :loading.sync="doSubmitLoading" />
				<div class="v-form-tips">请上传2:1的全景图片，例如：宽6000px，高3000px，拖拽可以进行排序</div>
			</el-form-item>
			<el-form-item v-if="vForm.type == 2" prop="info.url" label="全景链接" :rules="{required:true,message:'全景链接必填'}">
				<el-input v-model="vForm.info.url" placeholder="请输入链接"></el-input>
				<div class="v-form-tips">链接必须以https开头</div>
			</el-form-item>
			<el-form-item v-if="vForm.type != 2" label="作品Logo">
				<v-upload-image v-model="vForm.logo" />
				<div class="v-form-tips">尺寸150*150px以内，根据长边缩放展示</div>
			</el-form-item>
      <el-form-item label="地图图标">
        <v-upload-image v-model="vForm.worksIcon" />
        <div class="v-form-tips">（选填）上传后会覆盖分类图标</div>
      </el-form-item>
      <el-form-item v-if="vForm.worksIcon" label="图标文字颜色">
        <el-color-picker v-model="vForm.worksColor"></el-color-picker>
        <div class="v-form-tips">（选填）填写后会覆盖分类图标文字颜色</div>
      </el-form-item>
			<el-form-item v-if="vForm.type != 2" label="购票小程序ID">
				<el-input v-model="vForm.info.appId" placeholder="请输入小程序原始id"></el-input>
				<div class="v-form-tips">原始id以gh_开头</div>
			</el-form-item>
			<el-form-item v-if="vForm.type != 2" label="小程序路径">
				<el-input v-model="vForm.info.path" placeholder="请输入小程序跳转路径"></el-input>
			</el-form-item>
      <el-form-item label="启用状态">
        <el-switch
          v-model="vForm.isShow"
          :active-value="1"
          :inactive-value="2">
        </el-switch>
      </el-form-item>
			<!--			<el-form-item label="作品描述">-->
			<!--				<el-input v-model="vForm.remark" type="textarea" :rows="3"></el-input>-->
			<!--				<div class="v-form-tips">描述字数建议300字符以内，当前字符数：{{ vForm.remark.length }}</div>-->
			<!--			</el-form-item>-->
			<!--			<el-form-item label="展示状态" required>-->
			<!--				<el-radio v-model="vForm.isRecommend" :label="1">启用</el-radio>-->
			<!--				<el-radio v-model="vForm.isRecommend" :label="2">禁用</el-radio>-->
			<!--			</el-form-item>-->
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button size="small" @click="closeDialog">关闭</el-button>
			<el-button type="primary" :loading="doSubmitLoading" size="small" @click="doSubmit">确 定</el-button>
		</div>
		<map-point v-if="isShowMapDialog" :show.sync="isShowMap" :marker-data="markerData" :lng.sync="vForm.lng" :lat.sync="vForm.lat"></map-point>
	</el-dialog>
</template>

<script>
	import vrUpload from './vr-upload';
	import mapPoint from './map-point';

	export default {
		components: {vrUpload, mapPoint},
		props: {
			show: {
				type: Boolean,
				default: false
			},
			row: {
				type: Object,
				default: null
			}
		},

		data() {
			return {
				doSubmitLoading: false,
				loading: false,
				categoryLoading: false,
				category: [],
				vForm: {
					sort: 0,
					id: '',
					name: '',
					remark: '',
					lng: 0,
					lat: 0,
					logo: '',
					worksIcon: '',
					worksColor: '',
					categoryId: [], //分类id
					materialData: [],//资源id
					isRecommend: 1,//1启用 2禁用
					type: 1,//1站内作品  2站外作品
					remarkTime:'',
					isShow:1,
					info: {
						url: '',
						appId: '',
						path: ''
					}
				},
				isShowMap: false,
				isShowMapDialog: false
			}
		},

		computed: {
			markerData() {
				let row = this.category.find(item => item.id == this.vForm.categoryId[0]) || {};
				return {iconPreview: row.iconPreview || '', color: row.color || '', name: this.vForm.name}
			}
		},

		created() {
			this.getCategory();
			if (this.row) {
				Object.assign(this.vForm, this.row);
				this.vForm.lat = Number(this.vForm.lat);
				this.vForm.lng = Number(this.vForm.lng);
				this.vForm.info = this.vForm.info || {url: ''}
			}
		},

		methods: {

			async getCategory() {
				this.categoryLoading = true;
				try {
					let res = await this.api.category.lists();
					this.category = res.data;
				} catch (e) {
					console.error(e)
				}
				this.categoryLoading = false;
			},

			closeDialog() {
				this.$emit('update:show', false);
			},

			//提交作品
			async doSubmit() {
				this.doSubmitLoading = true;
				try {
					await this.$refs.vForm.validate();
					await this.api.works[this.row ? 'edit' : 'add'](this.vForm);
					this.$message.success(!this.row ? '添加成功' : '修改成功');
					this.$emit('success', this.row ? '' : 1);
					this.closeDialog();
				} catch (e) {
					console.error(e)
				}
				this.doSubmitLoading = false;
			}
		}
	}
</script>

